// web/app/lib/logger.ts

// Helper function to extract the core message by removing potential prefixes
const getCoreMessage = (message: string): string => {
  // Remove common prefixes like [API /logs] if present
  return message.replace(/^\[[^\]]+\]\s*/, '');
};

// Simple console logging wrapper
export const logger = {
  debug: (message: string, context?: Record<string, any>) => {
    if (process.env.NODE_ENV !== 'production' || process.env.LOG_LEVEL === 'debug') {
      const coreMessage = getCoreMessage(message);
      console.debug(JSON.stringify({ message: coreMessage, ...context }));
    }
  },
  
  info: (message: string, context?: Record<string, any>) => {
    const coreMessage = getCoreMessage(message);
    console.info(JSON.stringify({ message: coreMessage, ...context }));
  },
  
  warn: (message: string, context?: Record<string, any>) => {
    const coreMessage = getCoreMessage(message);
    console.warn(JSON.stringify({ message: coreMessage, ...context }));
  },
  
  error: (message: string, context?: Record<string, any>) => {
    const coreMessage = getCoreMessage(message);
    
    let logContext: Record<string, any> = {};
    let errorForLog: Record<string, any> | undefined = undefined;

    if (context) {
      const { error, ...restContext } = context;
      logContext = restContext;

      if (error) {
        if (error instanceof Error) {
          errorForLog = {
            error: {
              name: error.name,
              message: error.message,
              stack: error.stack,
            }
          };
        } else {
          errorForLog = { error };
        }
      }
    }

    console.error(JSON.stringify({ message: coreMessage, ...logContext, ...errorForLog }));
  }
};